var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.7812H8C7.45333 17.7812 7 17.3279 7 16.7812C7 16.2346 7.45333 15.7812 8 15.7812H24C24.5467 15.7812 25 16.2346 25 16.7812C25 17.3279 24.5467 17.7812 24 17.7812Z",
    fill: "#0D2645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.7812C15.4533 25.7812 15 25.3279 15 24.7812V8.78125C15 8.23458 15.4533 7.78125 16 7.78125C16.5467 7.78125 17 8.23458 17 8.78125V24.7812C17 25.3279 16.5467 25.7812 16 25.7812Z",
    fill: "#0D2645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.192e2158d32187fabe2916406574fa7f.svg";
export { ForwardRef as ReactComponent };